import { inject } from "mobx-react";
import { useMemo } from "react";
import { isPublishRecord } from "../../../../core/lib/guards";
import { reverseRoute } from "../../../../core/lib/route";
import { DATETIME_DISPLAY_FORMATS, zonedTimeFormat } from "../../../../core/lib/time";
import { MagicLink } from "../../../../core/ui";
import { CoastFeedShowItemProps } from "./CoastFeedShowItem.component";
import { CoastShowDate } from "./CoastShowDate.component";

export const CoastFeedUpcomingShowsPreviewItem = inject("store")(({ item, store }: CoastFeedShowItemProps) => {
  const { record } = item;

  if (!store || !isPublishRecord(record)) {
    return null;
  }

  const { slug, payload } = record;
  const { summary } = payload;
  const timezone = store.site.index?.timeZone || "UTC";
  const showUrl = reverseRoute(store.site, "shows_detail", { slug }) || "#";

  const showDayOfWeek = useMemo(
    () =>
      zonedTimeFormat({
        date: record.payload.fields.show_date.value || record.pub_start,
        outputFormat: DATETIME_DISPLAY_FORMATS.SHORT_DAY_OF_WEEK_TWELVE_HOUR_UNPADDED,
        timezone,
      }),
    [record.payload.fields.show_date.value, record.pub_start, timezone],
  );

  return (
    <div className="coast-feed-item">
      <div className="short-date">
        <CoastShowDate item={record} isShortDate={true} store={store} />
      </div>
      <div>
        <MagicLink to={showUrl} context={slug} className="item-title">
          <span className="title">{summary.title}</span>
          <span className="date">{showDayOfWeek}</span>
        </MagicLink>
      </div>
    </div>
  );
});
